import {
  GetRoktTransactionAttributesResp,
  RoktCartItem,
  RoktCartItemDto,
  RoktTransactionAttributes,
} from '../types/rokt-transaction-attributes'

export const transformRoktCartItem = (cartItem: RoktCartItemDto): RoktCartItem => ({
  minorCatID: cartItem.minor_cat_id,
  minorCat1: cartItem.minor_cat1,
})

export const transformRoktTransactionAttributes = ({
  billing_zip_code,
  amount,
  currency,
  cart_items,
  age,
}: GetRoktTransactionAttributesResp): RoktTransactionAttributes => ({
  billingzipcode: billing_zip_code,
  cartItems: cart_items.map(transformRoktCartItem),
  currency,
  amount,
  age,
})
